import RegistrationTracker from '../../RegistrationTracker';

export const trackRegistrationEvent = (
  step: number,
  gradeCode: string,
  subset?: string,
): void => {
  const tracker = new RegistrationTracker();
  tracker.track(step, { subset, gradeCode });
};

// Event design => https://docs.google.com/spreadsheets/d/1jj9km7Iu0yv2dTLWnUWoaeW6ymU-OTHM8qL8QqTsK40/edit#gid=1969258128
export const trackOptimizelyCustomEvent = (eventName: string): void => {
  (window as any).optimizely = (window as any).optimizely || [];
  (window as any).optimizely.push(['trackEvent', eventName]);
};
